<h3 class="ui primary header" >{{ modal.context.title }}
	<i class="link times icon" (click)="modal.deny(undefined)"></i>
	</h3>
 <div class="content" >
       <div class="scroll-wrapper ui basic segment" [ngClass]="{'loading':pending}">
      <div *ngIf="success || error" tamsyMargin marginY="10px">
            <esl-message-toast [(message)]="error"></esl-message-toast>
            <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
            </div>
         <!--Laboratory form  -->
         <!-- <div class="ui basic segment"> -->
 <div fxLayout="column" fxLayoutGap="25px">

                                          <div fxLayout="column">
                                                <div fxFlex><strong>Transaction ID</strong></div>
                                                <div fxFlex>{{detailTransaction?.invoiceTransactionAccountId}}</div>
                                          </div>
                                          <div fxLayout="column" >
                                                <div fxFlex><strong >Description </strong></div>
                                                <div fxFlex>{{detailTransaction?.remark}}</div>
                                          </div>


                                          <div fxLayout="column" >
                                                <div fxFlex><strong>Credited Amount </strong></div>
                                                <div fxFlex>{{detailTransaction?.creditAmount | number:'.2-2'}}</div>
                                          </div>

                                          <div fxLayout="column" >
                                                <div fxFlex><strong>Debited Amount</strong></div>
                                                <div fxFlex>{{detailTransaction?.debitAmount | number:'.2-2'}}</div>
                                          </div>

                                          <div fxLayout="column" >
                                                <div fxFlex><strong>Status</strong></div>
                                                <div fxFlex><span class="ui label" [ngClass]="{'green':detailTransaction.status =='OKAY'}">{{detailTransaction?.status}}</span></div>
                                          </div>

                                          <div fxLayout="column" >
                                                <div fxFlex><strong>Transaction Date </strong></div>
                                                <div fxFlex>{{detailTransaction?.dateCreated | date}}</div>
                                          </div>

                           </div>

            </div>
            </div>





